import React, { Component } from "react"
import AnchorLink from "react-anchor-link-smooth-scroll"
import Scrollspy from "react-scrollspy"
import { Menu, X } from "react-feather"
import styled from "styled-components"
import Img from "gatsby-image"
import { Helmet } from "react-helmet"

import { Container } from "../../global"
import {
  Nav,
  NavItem,
  Brand,
  StyledContainer,
  NavListWrapper,
  MobileMenu,
  Mobile,
  ActionsContainer,
  HomeLink,
} from "./style"

const NAV_ITEMS = ["Caracteristicas", "Product", "Pricing", ""]

export default class Navigation extends Component {
  state = {
    mobileMenuOpen: false,
    hasScrolled: false,
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
  }

  handleScroll = event => {
    const scrollTop = window.pageYOffset

    if (scrollTop > 32) {
      this.setState({ hasScrolled: true })
    } else {
      this.setState({ hasScrolled: false })
    }
  }

  toggleMobileMenu = () => {
    this.setState(prevState => ({ mobileMenuOpen: !prevState.mobileMenuOpen }))
  }

  closeMobileMenu = () => {
    if (this.state.mobileMenuOpen) {
      this.setState({ mobileMenuOpen: false })
    }
  }

  getNavAnchorLink = item => (
    <AnchorLink href={`#${item.toLowerCase()}`} onClick={this.closeMobileMenu}>
      {item}
    </AnchorLink>
  )

  getNavList = ({ mobile = false }) => (
    <NavListWrapper mobile={mobile}>
      <Scrollspy
        items={NAV_ITEMS.map(item => item.toLowerCase())}
        currentClassName="active"
        mobile={mobile}
        offset={-64}
      >
        {NAV_ITEMS.map(navItem => (
          <NavItem key={navItem}>{this.getNavAnchorLink(navItem)}</NavItem>
        ))}
      </Scrollspy>
    </NavListWrapper>
  )

  render() {
    const { mobileMenuOpen } = this.state
    console.log(this.props)

    return (
      <Nav {...this.props} scrolled={this.state.hasScrolled}>
        <Helmet
          defer={false}
          defaultTitle={"Ecolote"}
          titleTemplate={`%s | Ecolote`}
        >
          <meta name="description" content="Ecolote aplicacion ecologica" />
          <meta
            name="google-site-verification"
            content="n3U6qAjWxDJdA2RMnrWHyGnjXsglw9ppRYyvaNbnKD0"
          />
          <meta name="robots" />
          <meta name="googlebot" />
        </Helmet>
        <StyledContainer>
          <HomeLink href="/">
            <Brand>
              <ImageWrapperBack>
                <SomeImage fluid={this.props.data.childImageSharp.fluid} />
              </ImageWrapperBack>
              Ecolote
            </Brand>
          </HomeLink>
          {!this.props.hide && (
            <Mobile>
              <button
                onClick={this.toggleMobileMenu}
                style={{ color: "black", background: "none" }}
              >
                {this.state.mobileMenuOpen ? (
                  <X size={24} alt="close menu" />
                ) : (
                  <Menu size={24} alt="open menu" />
                )}
              </button>
            </Mobile>
          )}

          {!this.props.hide && <Mobile hide>{this.getNavList({})}</Mobile>}
          
        </StyledContainer>
        {!this.props.hide && (
          <Mobile>
            {mobileMenuOpen && (
              <MobileMenu>
                <Container>{this.getNavList({ mobile: true })}</Container>
              </MobileMenu>
            )}
          </Mobile>
        )}
      </Nav>
    )
  }
}

const ImageWrapperBack = styled.div`
  width: 50px;
  margin-right: 5px;
  object-fit: contain;
  @media (max-width: ${props => props.theme.screen.md}) {
    justify-self: center;
    width: 50px;
  }
`

const SomeImage = styled(Img)`
  object-fit: contain !important;
  @media (max-width: ${props => props.theme.screen.md}) {
    width: 40px;
  }
  @media (max-width: ${props => props.theme.screen.sm}) {
    width: 30px;
  }
`
